// Article image lightbox — click to expand
(function () {
  var overlay = document.createElement('div');
  overlay.className = 'article-lightbox';
  overlay.innerHTML = '<button class="article-lightbox__close" aria-label="Close">&times;</button><img src="" alt="">';
  document.body.appendChild(overlay);

  var overlayImg = overlay.querySelector('img');
  var closeBtn = overlay.querySelector('.article-lightbox__close');

  function open(src, alt) {
    overlayImg.src = src;
    overlayImg.alt = alt || '';
    overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    overlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  overlay.addEventListener('click', function (e) {
    if (e.target !== overlayImg) close();
  });
  closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  var content = document.querySelector('.blog-article__body');
  if (!content) return;

  content.querySelectorAll('img').forEach(function (img) {
    img.addEventListener('click', function () {
      open(img.src, img.alt);
    });
  });
})();
